<template lang="pug">
  l-geoJson(
    v-if="show"
    :geojson="geoJson"
    :options="options"
    :optionsStyle="styleFunction"
  )
</template>

<script>
import { mapGetters } from 'vuex'
import { tooltipOptions } from '@/constants.js'

const buildPopup = item => (
  `
    <h4>${item['NOMBRE']}</h4>
  `
)

export default {
  data () {
    return {
      show: false,
      fillColor: '#e4ce7f',
      options: {
        filter: (feature, layer) => feature.geometry,
        onEachFeature: (feature, layer) => {
          layer.bindTooltip(buildPopup(feature.properties), { ...tooltipOptions, permanent: false, sticky: true })
        },
        fillColor: '#000000'
      }
    }
  },
  methods: {
    styleFunction () {
      const fillColor = this.fillColor // important! need touch fillColor in computed for re-calculate when change fillColor
      return () => {
        return {
          weight: 2,
          color: '#ECEFF1',
          opacity: 1,
          fillColor,
          fillOpacity: 1
        }
      }
    }
  },
  computed: {
    ...mapGetters({ geoJson: 'coberturasCentroMunicipal' })
  },
  watch: {
    geoJson () {
      this.show = !!(this.geoJson && this.geoJson.features && this.geoJson.features.length)
      this.fillColor = this.fillColor === '#878787' ? '#e4ce7f' : '#878787'
    }
  }
}
</script>
